export default __webpack_public_path__ + "static/media/tips.b7edd49a.svg";